import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { useNavigate } from 'react-router-dom';

export default function CardsHomeComponent({ imagem, titulo, descricao, rota }) {
  const navigate = useNavigate();

  const redirect = () => {
    navigate(`/${rota}`);
  };
  return (
    <Card
        sx={{
            maxWidth: 400,
            height: "100%",
            display: "flex",
            flexDirection: "column",
        }}
        onClick={redirect}
        style={{ cursor: 'pointer', borderRadius: "15px" }}
        elevation={24}
        >
        <CardActionArea sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CardMedia
            component="img"
            height="140"
            image={imagem}
            alt={titulo}
            />

            <CardContent sx={{ flex: 1 }}>
            <Typography gutterBottom variant="h5" component="div">
                {titulo}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {descricao}
            </Typography>
            </CardContent>
        </CardActionArea>
    </Card>
  );
}
